module.exports = __webpack_public_path__ + "media/src/assets/Images/LoginMobileBackground-b670e1728f88fc311874fa9addf5ac3c.svg";